// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/**\n超出图片限制隐藏上传图片框\n*/\n[data-v-2eca24fd] .hide .el-upload--picture-card {\n  display: none;\n}\n/** 设置上传框大小以及设置上传图片成功之后得图片大小 */\n[data-v-2eca24fd] .el-upload {\n  width: 100px;\n  height: 100px;\n}\n[data-v-2eca24fd] .el-upload .el-upload-dragger {\n  width: 100%;\n}\n[data-v-2eca24fd] .el-upload-list--picture-card .el-upload-list__item {\n  width: 100px;\n  height: 100px;\n}\n", ""]);
// Exports
module.exports = exports;
